import request from '@/request'
import type * as TYPE from './types'

/**
 * 用户登录
 * @param account 账号
 * @param password 密码
 */
export const login = (params: TYPE.LoginParams): Promise<ResponseData<TYPE.LoginResponseData>> => {
  return request.post('/manage/login', params)
}

/**
 * 退出登录
 */
export const logout = (): Promise<ResponseData<object>> => {
  return request.get('/manage/logout')
}

/**
 * 获取设备绑定的用户信息
 */
export const getBindUserInfo = (params: {
  userId: number
}): Promise<
  ResponseData<{
    userId: number
    openid: string
    unionid: string
    phone: string
    nickname: string
    avatarUrl: string
    gender: 0 | 1 | 2
    country: string
    province: string
    city: string
    language: string
  }>
> => {
  return request.post('/admin/query/wxUser', params)
}

export const queryWxUserOptions = (params: {
  keyword?: string
  tenantId?: string | null
  userId?: string | null
}): Promise<
  ResponseData<
    {
      userId: string | number
      nickname?: string | null
      phone?: string | null
    }[]
  >
> => {
  return request.post('/admin/query/wxUserOptions', params)
}

/**
 * 解绑用户
 * @param devId 设备id
 */
export const unbindUser = (params: { devId: string }): Promise<ResponseData<object>> => {
  return request.post('/admin-deal/unbind', params)
}

/**
 * 用户管理
 * @description 用户管理 查询用户列表
 */
export const queryUserList = (params: {
  pageNo: number
  pageSize: number
  account: string
  phone?: string
  userName: string
  userType: string | null
  enableFlag: SwitchType | null
  tenantId?: string | null
  tenantIds?: string[]
}): Promise<ResponseData<TYPE.QueryUserListResponseData>> => {
  return request.post('/admin/query', params)
}

/**
 * 用户管理
 * @description 用户管理 新增用户
 */
export const addUser = (params: {
  account: string
  password: string
  userName: string
  tenantId: string | null
  userType: string | null
  phone: string
  roleIds: string[]
  gender: string
  birthDate: string | null
  remark: string | null
}): Promise<ResponseData<object>> => {
  return request.post('/admin/add', params)
}

/**
 * 用户管理
 * @description 用户管理 更新用户信息
 */
export const updateUserInfo = (params: {
  userId: string
  account: string
  tenantId: string | null
  userName: string | null
  userType: string | null
  phone: string
  roleIds: string[]
  gender: string
  birthDate: string | null
  remark: string | null
}): Promise<ResponseData<object>> => {
  return request.post('/admin/mod', params)
}

/**
 * 用户管理
 * @description 用户管理 更新用户状态
 */
export const updateEnableStatus = (params: { userId: string }): Promise<ResponseData<object>> => {
  return request.get(`/admin/updateEnableStatus?userId=${params.userId}`)
}
// 删除用户
export const deleteUser = (params: { userId: string }): Promise<ResponseData<object>> => {
  return request.get(`/admin/del?userId=${params.userId}`)
}
// 修改密码
export const updatePassword = (params: {
  oldPassword: string
  newPassword: string
  confirmNewPassword: string
}): Promise<ResponseData<object>> => {
  return request.post('/user/updatePassword', params)
}
